import React from "react"
import {
	CardActionArea,
	Box,
	Button,
	Typography,
	makeStyles,
	Grid,
} from "@material-ui/core/"
import { useTranslation } from "react-i18next"
import { ReactComponent as Airplane } from "../img/airplane.svg"
import { ReactComponent as Car } from "../img/car.svg"
import { ReactComponent as PublicTransport } from "../img/public-transport.svg"
import { ReactComponent as Footprint } from "../img/footprint.svg"
import { Link as RouterLink } from "react-router-dom"
import CalcCard from "../components/CalcCard"
const useStyles = makeStyles((theme) => ({
	whiteFill: {
		fill: "#ffffff",
	},
}))

const PopularCalcs = ({ alt }) => {
	const { t, i18n } = useTranslation()
	const classes = useStyles()
	const lang = i18n.language == "en" ? "" : "/nl"

	return (
		<Grid
			container
			direction="row"
			justify="center"
			alignItems="stretch"
			spacing={3}
			style={{ paddingTop: 30, zIndex: 2, position: "relative" }}
		>
			<Grid item xs={12}>
				<Typography align="center" variant="h3" component="h2" color="initial">
					{t("home.populartitle")}
				</Typography>
				<Typography align="center" variant="body1" color="initial">
					{t("home.popularintro")}
				</Typography>
			</Grid>
			<Grid item xs={6} sm={3}>
				<CalcCard
					title={t("transport.flight")}
					icon={<Airplane />}
					content={t("home.flightsintro")}
					url={t("/calculate-your-flights")}
				/>
			</Grid>
			<Grid item xs={6} sm={3}>
				<CalcCard
					title={t("transport.car")}
					icon={<Car className={classes.whiteFill} />}
					content={t("home.carintro")}
					url={t("/calculate-your-car")}
				/>
			</Grid>
			<Grid item xs={6} sm={3}>
				<CalcCard
					title={t("transport.publictransport")}
					icon={<PublicTransport />}
					content={t("home.publictransportintro")}
					url={t("/calculate-your-public-transport")}
				/>
			</Grid>
			<Grid item xs={6} sm={3}>
				<CalcCard
					title={t("home.footprint")}
					icon={<Footprint />}
					content={t("home.footprintintro")}
					url={t("/footprint-calculator")}
				/>
			</Grid>
		</Grid>
	)
}

export default PopularCalcs
